import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home/Home.jsx';
import Products from './components/Products/Products.jsx';
import ProductOrCategory from './components/Products/ProductOrCategory.jsx';
import About from './components/About/About.jsx';
import Contact from './components/Contact/Contact.jsx';
import ThankYou from './components/ThankYou/ThankYou.jsx';
import Privacy from './components/Privacy/Privacy.jsx';
import Terms from './components/Terms/Terms.jsx';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton.jsx';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/products/:slug" element={<ProductOrCategory />} />
        </Routes>
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
